import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { authSession } from '@/lib/api';
import { useAuth } from '@/lib/auth';
import { toast } from 'sonner';

// All admin sign-ins land on /admin after OAuth completes. We intentionally do
// NOT read a redirect target from browser storage — that would allow tampering.
const POST_AUTH_TARGET = '/admin';

export default function AuthCallback() {
    const navigate = useNavigate();
    const location = useLocation();
    const { refresh } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;
        const hash = location.hash || '';
        const params = new URLSearchParams(hash.startsWith('#') ? hash.slice(1) : hash);
        const sessionId = params.get('session_id');
        if (!sessionId) {
            navigate('/admin/login', { replace: true });
            return;
        }
        (async () => {
            try {
                const user = await authSession(sessionId);
                await refresh();
                if (user.role !== 'admin') {
                    toast.error('This Google account is not authorised for admin access.');
                    navigate('/', { replace: true });
                    return;
                }
                toast.success(`Welcome back, ${user.name || user.email}`);
                navigate(POST_AUTH_TARGET, { replace: true });
            } catch (e) {
                toast.error('Sign-in failed. Please try again.');
                navigate('/admin/login', { replace: true });
            }
        })();
    }, [location.hash, navigate, refresh]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-la-canvas text-la-text2">
            Signing you in…
        </div>
    );
}
